import { useState, useEffect } from 'react'

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })
  const isMobileSize = screenSize.width < 768
  const isTabletSize = screenSize.width >= 768 && screenSize.width < 1024
  const isDesktopSize = screenSize.width >= 1024

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return { screenSize, isMobileSize, isTabletSize, isDesktopSize }
}

export default useScreenSize